export const LEASE = 'lease';
export const FINANCE = 'finance';
export const CASH_PURCHASE = 'cashPurchase';
export const BEST_PAYMENT = 'bestPayment';

export default {
    LEASE,
    FINANCE,
    CASH_PURCHASE,
    BEST_PAYMENT,
};



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js